const LOGO_URL =
  "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/9bbf6cf8-b106-4501-9333-f0d6926a8c4e_compressed_1631335680439.webp";

const SITE_URL = import.meta.env.VITE_SITE_URL;

export const homePageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      name: "Amin & Jahan Corporation Ltd.",
      url: `${SITE_URL}/`,
      logo: LOGO_URL,
      image: LOGO_URL,
      slogan: "Research. Develop. Promote.",
      description:
        "Amin & Jahan Corporation Ltd. is an integrated research, development and promotion service provider connecting knowledge, capability, industry and innovation across Bangladesh's textile and apparel ecosystem.",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Road: 3, House: 47, 2nd Floor, Sector 13, Uttara",
        addressLocality: "Dhaka",
        postalCode: "1230",
        addressCountry: "BD",
      },
      sameAs: [
        "https://www.textiletoday.com.bd/",
        "https://training.textiletoday.com.bd/",
        "https://www.linkedin.com/company/textile-today",
      ],
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: "Amin & Jahan Corporation Ltd.",
      publisher: { "@id": `${SITE_URL}/#organization` },
    },
  ],
};